var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('t-upload',{attrs:{"accept":_vm.acceptedFileTypes.join(', ')},on:{"input":_vm.onSelectFile},scopedSlots:_vm._u([{key:"default",fn:function(ref){
var on = ref.on;
return [_vm._t("default",null,null,{
      on: on,
      isCompressing: _vm.isCompressing,
      isCompressed: _vm.isCompressed,
      isTransformFile: _vm.isTransformFile,
      originFile: _vm.originFile,
      transformFile: _vm.transformFile,
      onSelectFile: _vm.onSelectFile,
      compareImage: _vm.compareImage,
      reset: _vm.reset,
    })]}}],null,true)})}
var staticRenderFns = []

export { render, staticRenderFns }